import { configureStore } from "@reduxjs/toolkit";
import { Middleware } from "redux";

import { baseApi } from "./api";
import { rootReducer } from "../reducers";

const middlewareList: Middleware[] = [baseApi.middleware];

export function getStore() {
  return configureStore({
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }).concat(middlewareList),
    reducer: {
      [baseApi.reducerPath]: baseApi.reducer,
      ...rootReducer,
    },
  });
}

export const store = getStore();
